var Acr = Acr || {};

Acr.HorizontalMultitab = function () {
  var $horizontalMultitab;
  var $horizontalMultitabTabs;
  var $horizontalMultitabTabsContent;
  var $desktopMedia;
  var horizontalMultitabCurrentTheme;
  const tabSelectorClass = '.js-multitab-tab-item';
  const tabContentSelectorClass = '.js-multitab-tab-content';
  const desktopMediaSelectorClass = '.js-desktop-media';
  const tabActiveClass = 'acr-horizontal-multitab__tab-item--active';
  const tabContentActiveClass = 'acr-horizontal-multitab__tab-content--active';
  const desktopMediaActiveClass = 'acr-horizontal-multitab__desktop-media--active';
  const jsModuleClass = '.js-module';
  const lightTheme = 'light-theme';

  function initSelectors(element) {
    $horizontalMultitab = element;
    $horizontalMultitabTabs = $horizontalMultitab.querySelectorAll(tabSelectorClass);
    $horizontalMultitabTabsContent = $horizontalMultitab.querySelectorAll(tabContentSelectorClass);
    $desktopMedia = $horizontalMultitab.querySelectorAll(desktopMediaSelectorClass);
  }

  function bindEvents() {
    // Attachment of click events for each of the tabs
    $horizontalMultitabTabs.forEach(function (tab) {
      tab.addEventListener('click', tabClickHandler);
    });
  }

  // Function that is called when a tab is clicked
  function tabClickHandler() {
    var clickedTabId = this.getAttribute('tab-id');
    updateTabsStatus(clickedTabId);
    updateDesktopMedia(clickedTabId);
    if (horizontalMultitabCurrentTheme) {
      updateTheme(clickedTabId);
    }
    resetContent(clickedTabId);
  }

  // Function to set a tab and its content as an "active" tab when a new tab is clicked.
  function updateTabsStatus(paramTargetTab) {
    $horizontalMultitabTabs.forEach(function (tab) {
      var tabId = tab.getAttribute('tab-id');
      if (tabId === paramTargetTab) {
        tab.classList.add(tabActiveClass);
      } else {
        tab.classList.remove(tabActiveClass);
      }
    });
    $horizontalMultitabTabsContent.forEach(function (tabContent) {
      var tabContentId = tabContent.getAttribute('id');
      if (tabContentId === paramTargetTab) {
        tabContent.classList.add(tabContentActiveClass);
      } else {
        tabContent.classList.remove(tabContentActiveClass);
      }
    });
  }

  // Function to change a desktop media element as "active" when a new tab is clicked.
  function updateDesktopMedia(paramTargetTab) {
    $desktopMedia.forEach(function (item) {
      var relatedTabId = item.getAttribute('related-tab-id');
      if (relatedTabId === paramTargetTab) {
        item.classList.add(desktopMediaActiveClass);
      } else {
        item.classList.remove(desktopMediaActiveClass);
      }
    });
  }

  // Function that is called to change the theme of the component
  function updateTheme(paramTargetTab) {
    var $horizontalMultitabTab = $horizontalMultitab.querySelector('#' + paramTargetTab);
    var dataTheme = $horizontalMultitabTab.getAttribute('data-theme');
    var dataBgColor = $horizontalMultitabTab.getAttribute('data-bg-color');
    $horizontalMultitab.classList.remove(horizontalMultitabCurrentTheme);
    if (dataTheme === '') {
      horizontalMultitabCurrentTheme = lightTheme;
    } else {
      horizontalMultitabCurrentTheme = dataTheme;
    }
    $horizontalMultitab.classList.add(horizontalMultitabCurrentTheme);
    $horizontalMultitab.style.backgroundColor = dataBgColor;
  }

  // Function that sets the current theme being used when the page loads
  function setInitialTheme() {
    var $currentActiveTab = $horizontalMultitab.querySelector('.' + tabContentActiveClass);
    var horizontalMultitabCurrentBg = $currentActiveTab.getAttribute('data-bg-color');
    horizontalMultitabCurrentTheme = $currentActiveTab.getAttribute('data-theme');
    if (horizontalMultitabCurrentTheme === '') {
      horizontalMultitabCurrentTheme = lightTheme;
    }
    if (horizontalMultitabCurrentBg) {
      $horizontalMultitab.style.backgroundColor = horizontalMultitabCurrentBg;
    }
    if (horizontalMultitabCurrentTheme) {
      $horizontalMultitab.classList.add(horizontalMultitabCurrentTheme);
    }
  }

  function resetContent(paramTargetTab) {
    var $horizontalMultitabTab = $horizontalMultitab.querySelector('#' + paramTargetTab);
    var $modules = $horizontalMultitabTab.querySelectorAll(jsModuleClass);

    for (var modulesIndex = 0; modulesIndex < $modules.length; modulesIndex++) {
      var moduleId = $modules[modulesIndex].dataset.moduleId;

      if (moduleId) {
        var currentModule = Acr.Modules[moduleId];
        if (currentModule.reset) {
          currentModule.reset();
        }
      }
    }
  }

  function init(element) {
    initSelectors(element);
    if ($horizontalMultitab.querySelector('.' + tabContentActiveClass)) {
      setInitialTheme();
      bindEvents();
    }
  }

  return {
    init: init,
  };
};
